var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 554.03459,
    height: 564.54076,
    viewBox: "0 0 554.03459 564.54076",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      userSelect: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 14.79004,
    y: 75.97998,
    width: 261.20996,
    height: 2.78027,
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.79004,
    y: 139.83008,
    width: 261.20996,
    height: 2.77002,
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.79004,
    y: 203.66992,
    width: 261.20996,
    height: 2.78027,
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.79004,
    y: 267.52002,
    width: 261.20996,
    height: 2.77002,
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.79004,
    y: 331.36035,
    width: 261.20996,
    height: 2.77979,
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.9827,564.09v2.88965h-261.76A1.38693,1.38693,0,0,1,335.8328,565.59V169.11976a1.385,1.385,0,1,1,2.77,0V295.99964q0,5.80518.25,11.56006c.02979.93017.07983,1.8501.12988,2.77a266.79322,266.79322,0,0,0,10.37012,61.06982c.27.93018.5398,1.86035.82983,2.78028a266.40259,266.40259,0,0,0,27.36011,61.06982c.56006.93018,1.12988,1.8501,1.71,2.77A268.94006,268.94006,0,0,0,431.63261,499.09c1.08007.93994,2.17016,1.85986,3.26,2.77979A266.97,266.97,0,0,0,598.9827,564.09Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.14262,168.16956a9.71509,9.71509,0,0,0,0,19.43018H598.9827V168.16956Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#e6e6e6",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.863 546.37 426.428 546.37 422.415 513.834 434.865 513.834 434.863 546.37",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.38617,726.54541a3.58787,3.58787,0,0,0,3.56513,3.57227h15.87914l.492-1.01962,2.246-4.63468.86988,4.63468.19253,1.01962h5.9894l-.08556-1.02676L759.93756,709.939l-2.08917-.12834-9.02691-.53477-2.21754-.13548v5.7185C744.9212,716.64858,731.71592,723.41521,732.38617,726.54541Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.622 539.983 503.636 542.699 489.36 513.188 501.147 509.18 511.622 539.983",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.508,727.69363a3.58789,3.58789,0,0,0,4.52553,2.23405l15.03341-5.11306.13747-1.12374.63407-5.11106,2.3159,4.10774.5106.90332,5.67041-1.92857-.41162-.94453-7.679-17.61763-2.01922.5512-8.71833,2.40036-2.14307.58579,1.84135,5.41393C823.18861,714.28765,812.86548,724.946,814.508,727.69363Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.0019,
    cy: 182.63827,
    r: 9.3999,
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.06087,363.98542a9.289,9.289,0,0,1-2.95639-12.96056,9.39991,9.39991,0,0,1,12.96056-2.95639c4.39534,2.76257,1.09516,8.11425,2.95639,12.96056C786.6544,367.88481,777.11362,367.50378,771.06087,363.98542Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.92816,487.18384h47.60807l4.09138,22.97753s18.88615,20.64994,10.2264,38.52467c0,0,6.01166,9.06413,2.85369,12.425s-8.90236,1.75933-3.158,5.17118,8.87768,1.53269,5.74438,4.82225,15.6665,67,15.6665,67l21.41911,60.43244L818.005,700.24823l-41.79789-60.02252L754.29873,561.111l9.47391,139.13719H741.27209l-11.25027-15.19985s4.44912-.78327,0-5.586-8.62686-5.31088-4.44912-7.14568-9.3999-43.08992-9.3999-43.08992Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.14484,473.86732s-6.2666,3.65551-3.1333,5.22216,3.1333,1.67768,3.1333,4.23325,1.04443,7.25552,2.61108,7.25552,14.62207,0,21.41088,12.011,32.89965,7.83325,32.89965,4.17774-1.8956-16.71094-5.12553-19.58313-6.36323-1.82776-3.75215-4.43884,6.78882-1.04443,3.65552-4.17773-5.74439-3.65552-5.74439-8.35547,10.96655-50.065,10.96655-50.065-1.04443-15.21213-8.87768-15.21213a12.45769,12.45769,0,0,1-10.96655-6.78882l-1.30554-10.18322-19.322-2.61108-4.43884,12.27209s-7.57214,8.61657-7.57214,11.22765-17.23315,18.27759-10.44433,29.76635,9.13879,3.91663,7.04992,9.13879S733.14484,473.86732,733.14484,473.86732Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.2356,361.07611c-.32667.76127-10.39928.6797-10.8606,1.35758-3.55684,5.23346,9.26489,27.50054,5.708,32.7408l-.4955.59055a23.4151,23.4151,0,0,0,3.33283-1.88026c.095-2.14495.19008-4.29674.29187-6.44169a17.70549,17.70549,0,0,1,2.55225,4.48678,29.05916,29.05916,0,0,1,5.057-3.7944,22.26109,22.26109,0,0,1,4.91889-4.04911Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.24594,
    cy: 201.36856,
    r: 16.67165,
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.89087,393.11489a8.0292,8.0292,0,0,1-2.688-4.41212,17.2511,17.2511,0,0,0,.2376,6.29913c-.9028.67878-1.77842,1.32364-2.60656,1.90739a17.70549,17.70549,0,0,0-2.55225-4.48678c-.10179,2.14495-.19683,4.29674-.29187,6.44169a23.41483,23.41483,0,0,1-3.33283,1.88025l.4955-.59054c3.55684-5.24026-5.64752-14.8858-2.09068-20.11927.99784-1.4662-3.50932-13.05307-6.944-13.57575-3.05454-.46157-2.92557.42085-5.88508,1.0657a14.80917,14.80917,0,0,0-1.41868-3.67226,12.13359,12.13359,0,0,1-.11538,3.8691c-1.05212.04072-1.87989-.62967-3.00023-.801-7.14766-1.09284-6.42135-8.8242-4.43251-11.27465,1.99564-2.44362,8.62061-3.17672,11.67516-3.97093.27828-.27149.90955-.1018,1.18788-.35974,5.85386-5.35734,13.683-6.24457,20.72853-3.87007,7.51351,2.53222,12.19806,7.4332,14.60235,14.98862l.68957,6.04627c.61865,1.94408-.15959,10.98967-.68957,12.95978C778.3997,389.09784,774.0122,385.27489,766.89087,393.11489Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#2f2e41",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.60516,510.84093a5.13081,5.13081,0,0,0,1.30916-7.0356,4.92236,4.92236,0,0,0-.51561-.62951l17.416-34.78943-9.89489-8.0676L706.1153,503.39767a5.11659,5.11659,0,0,0-.42409,6.23216,4.89654,4.89654,0,0,0,6.80386,1.28836Q712.55064,510.88032,712.60516,510.84093Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.79157,409.22861s-4.75651-10.26161-17.49846-.07818-23.1106,42.15093-22.93272,44.19665,1.78871.05913-.71846,4.12759c-2.03909,3.3089.62136,4.01213-.607,4.34984-3.239.89052,3.16512,4.13738-.98353,4.32075s10.6607,7.45624,10.6607,7.45624,2.40956-.452,3.416-5.90873c.56529-3.06483-.73688-4.8868,1.73618-5.278s.45958-6.0863.856-6.94666,15.10081-16.87492,15.10081-16.87492Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.05202,
    cy: 354.03315,
    r: 47.84253,
    fill: "#6c63ff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.09857,546.66258a5.32026,5.32026,0,0,1-4.257-2.12916l-13.05218-17.40319a5.3217,5.3217,0,1,1,8.51493-6.38576l8.53917,11.3847,21.93178-32.89723a5.32192,5.32192,0,1,1,8.85621,5.90415l-26.10434,39.15652a5.32412,5.32412,0,0,1-4.28042,2.36824C732.19731,546.66171,732.14794,546.66258,732.09857,546.66258Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.40309,518.95517a5.1308,5.1308,0,0,1,1.7761-6.93246,4.92152,4.92152,0,0,1,.73279-.35376L777.7699,472.7804l12.37247-3.14919L785.42432,514.938a5.11658,5.11658,0,0,1-2.24041,5.831,4.89655,4.89655,0,0,1-6.71353-1.69736Q776.43594,519.01386,776.40309,518.95517Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#a0616a",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.49988,406.49994s8.63627-7.30342,15.90339,7.29961,3.20608,47.96376,2.18307,49.74423-1.6472-.69979-1.087,4.0462c.45564,3.85993-2.25349,3.37713-1.28169,4.2008,2.56257,2.172-4.61335,2.41928-.92792,4.333s-12.8095,2.27214-12.8095,2.27214-1.995-1.42487-.6094-6.79787c.77823-3.01779,2.72668-4.12177.64848-5.51823s2.14678-5.71363,2.14966-6.66091-6.588-21.66554-6.588-21.66554Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#3f3d56",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.93864,714.58307a2.26934,2.26934,0,0,1-1.64468-3.93333l.15549-.61819q-.0307-.07427-.06178-.1484a6.09417,6.09417,0,0,0-11.24139.04177c-1.83858,4.42818-4.17942,8.86389-4.75579,13.54595a18.02888,18.02888,0,0,0,.31648,6.20046,72.28145,72.28145,0,0,1-6.57515-30.02076,69.76621,69.76621,0,0,1,.43275-7.783q.3585-3.17781.9947-6.31034a73.119,73.119,0,0,1,14.50012-30.98962,19.45891,19.45891,0,0,0,8.09295-8.39652,14.84311,14.84311,0,0,0,1.34992-4.05617c-.394.05167-1.48556-5.94866-1.18841-6.3168-.54906-.83317-1.53177-1.24733-2.13143-2.06034-2.98233-4.04341-7.0912-3.33742-9.23621,2.15726-4.58224,2.31266-4.62659,6.14806-1.81495,9.83683,1.78878,2.34682,2.03456,5.52233,3.60408,8.03478-.16151.20671-.32944.407-.4909.61366a73.59123,73.59123,0,0,0-7.681,12.1686,30.59231,30.59231,0,0,0-1.82641-14.20959c-1.74819-4.21732-5.0249-7.76915-7.91045-11.415a6.27921,6.27921,0,0,0-11.184,3.08332q-.00887.08062-.01731.1612.64288.36267,1.25863.76992a3.0782,3.0782,0,0,1-1.24106,5.60174l-.06277.00967a30.628,30.628,0,0,0,.80734,4.57938c-3.70179,14.31579,4.29011,19.5299,15.70147,19.76412.25191.12916.49738.25833.74929.38109a75.11519,75.11519,0,0,0-4.04327,19.02779,71.24459,71.24459,0,0,0,.05168,11.50323l-.01939-.13563a18.82558,18.82558,0,0,0-6.4266-10.87027c-4.9456-4.06264-11.93282-5.55869-17.26826-8.82426a3.533,3.533,0,0,0-5.41121,3.43708l.02182.14261a20.67715,20.67715,0,0,1,2.31871,1.11733q.6429.36276,1.25864.76992a3.07824,3.07824,0,0,1-1.24107,5.6018l-.06282.00965c-.0452.00646-.084.013-.12911.01944a30.65441,30.65441,0,0,0,5.63854,8.82922c2.31463,12.49712,12.256,13.68282,22.89022,10.04354h.00648a75.09338,75.09338,0,0,0,5.0444,14.7262h18.02019c.06463-.20022.12274-.40692.18089-.60717a20.47477,20.47477,0,0,1-4.98629-.297c1.337-1.64059,2.674-3.2941,4.011-4.93463a1.11772,1.11772,0,0,0,.084-.09689c.67817-.8396,1.36282-1.67283,2.041-2.51245l.00036-.001a29.99039,29.99039,0,0,0-.87876-7.63984Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#f2f2f2",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.34725,731.08038a1.18647,1.18647,0,0,0,1.19007,1.19h253.29a1.19,1.19,0,1,0,0-2.38h-253.29A1.1865,1.1865,0,0,0,621.34725,731.08038Z",
    transform: "translate(-322.9827 -167.72962)",
    fill: "#ccc",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 246.66016,
    r: 15,
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 315.66016,
    r: 15,
    fill: "#fff",
    style: {
      userSelect: "auto"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoted);
export default __webpack_public_path__ + "static/media/noted.58242755062e416e44f8a50e458a051f.svg";
export { ForwardRef as ReactComponent };